import steps from '@/modules/base/components/modal/onboarding-tester-modal/onboarding-steps/stepsConfig'

// Action Types
const ACTION_PREFIX = 'onboardingTester/mainSteps'
const SET_CURRENT_STEP_INDEX = `${ACTION_PREFIX}/SET_CURRENT_STEP_INDEX`
const NEXT_STEP = `${ACTION_PREFIX}/NEXT_STEP`
const PREV_STEP = `${ACTION_PREFIX}/PREV_STEP`
const SET_COMPANY_DATA = `${ACTION_PREFIX}/SET_COMPANY_DATA`
const SET_IS_SAVING = `${ACTION_PREFIX}/SET_IS_SAVING`
const RESET_STATE = `${ACTION_PREFIX}/RESET_STATE`

const initialState = {
  steps,
  currentStepIndex: 0,
  companyData: {
    companyName: '',
    street: '',
    zipCode: '',
    city: '',
    firstName: '',
    lastName: '',
    phone1: '',
    email: '',
  },
  isSaving: false,
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_CURRENT_STEP_INDEX:
      return {
        ...state,
        currentStepIndex: action.stepIndex,
      }

    case NEXT_STEP:
      return {
        ...state,
        currentStepIndex: Math.min(state.currentStepIndex + 1, state.steps.length - 1),
      }

    case PREV_STEP:
      return {
        ...state,
        currentStepIndex: Math.max(state.currentStepIndex - 1, 0),
      }

    case SET_COMPANY_DATA:
      return {
        ...state,
        companyData: {
          ...state.companyData,
          ...action.companyData,
        },
      }

    case SET_IS_SAVING:
      return {
        ...state,
        isSaving: action.isSaving,
      }

    case RESET_STATE:
      return initialState

    default:
      return state
  }
}

// Action Creators
export const setCurrentStepIndex = (stepIndex) => ({
  type: SET_CURRENT_STEP_INDEX,
  stepIndex,
})

export const nextStep = () => ({
  type: NEXT_STEP,
})

export const prevStep = () => ({
  type: PREV_STEP,
})

export const setCompanyData = (companyData) => ({
  type: SET_COMPANY_DATA,
  companyData,
})

export const setIsSaving = (isSaving) => ({
  type: SET_IS_SAVING,
  isSaving,
})

export const resetState = () => ({
  type: RESET_STATE,
})
